<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte';
    import { fetchTransporte, saveTransporte, removeTransporte, searchTransportes, subscribeToTransportes, unsubscribeFromTransportes } from '../controllers/transporteController.js';
    import { fetchUsers } from '../controllers/userController.js'; // Function to load users

    // Configuration for the transporte table columns
    let transporteColumns = [
        { label: 'Descripción', field: 'descrip', type: 'text' },
        { label: 'Teléfono', field: 'telefono', type: 'text' },
        { label: 'Email', field: 'email', type: 'text' },
        { label: 'Estado', field: 'sta', type: 'bool' },
    ];

    // Structure for a new transporte object
    let newTransporte = {
        descrip: '',
        telefono: '',
        email: '',
        sta: true,
        user: '', // Optional: Link to a user if needed
    };

    // Configuration for the edit form fields
    let editColumns = [
        { label: 'Descripción', key: 'descrip', type: 'text', required: true },
        { label: 'Teléfono', key: 'telefono', type: 'text', required: true },
        { label: 'Email', key: 'email', type: 'text', required: true },
        { label: 'Estado', key: 'sta', type: 'checkbox', required: true },
    ];

    // Load users when the component mounts
    onMount(() => {
    });
</script>

<CRUD 
    title="Transportes"
    entityName="transporte"
    newEntity={newTransporte}
    columns={transporteColumns}
    fetchEntities={fetchTransporte}
    saveEntity={saveTransporte}
    removeEntity={removeTransporte}
    searchEntities={searchTransportes}
    subscribeToChanges={subscribeToTransportes}
    unsubscribeFromChanges={unsubscribeFromTransportes}
    editColumns={editColumns}
/>